import { CreateAccountInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createAccountMutationAtom = createMutationAtomFactory(
  'crm.accountCreate',
  (input: CreateAccountInput) => ({
    crmAccountCreate: {
      __args: {
        input,
      },
      id: true,
    },
  }),
);
